import customTools from 'src/js/modules/custom-tools';
import spacerResizeToolSettings from '../tools/spacer-resize';

const initSpacer = () => {
  customTools.operations.registerTool(spacerResizeToolSettings);
};

export default initSpacer;
